import React, { Component } from 'react';
import classNames from 'classnames'

import {LangChangeEventContext} from '../../contexts/LangContext';

import styles from './index.css';

export default class Title extends Component {
  render() {
    return ( 
      <LangChangeEventContext.Consumer>
      {({lang}) =>(
         <div className={ classNames(styles.index, this.props.classStyle, styles[this.props.colorStyle]) } >
          
          <h1 className={ classNames(styles.title, this.props.logo && styles.logo) }>
            {this.props.title}
          </h1>

          <div className={ classNames(styles.logoWrapper, this.props.logo && styles.logo) } >
            <img alt="" src="/assets/logo.jpg" className={styles.logoWrapperImg} />
          </div>

          <div className={styles.text}>
            {this.props.text}
          </div>
         </div>
      )}
      </LangChangeEventContext.Consumer>
    );
  }
}
  



// WEBPACK FOOTER //
// ./src/blocks/Title/index.js